import { readBrowserStorageJSON, writeBrowserStorageJSON } from "../storage/browserStorage.js";
import type { NudgeType } from "@rosette/ts/src/business/nudge/NudgeType.js";
import { NudgeData } from "@rosette/ts/src/business/nudge/NudgeData.js";

function getNudgeStorageKey(nudgeType: NudgeType): string {
    return `nudge-${nudgeType.getID()}`;
}

export function loadNudge(nudgeType: NudgeType): NudgeData {
    const key = getNudgeStorageKey(nudgeType);
    const stored = readBrowserStorageJSON(key);

    const saveFn = () => saveNudge(nudgeType, nudgeData);
    let nudgeData: NudgeData;
    try {
        nudgeData = NudgeData.deserialize(nudgeType, saveFn, stored);
    } catch (error) {
        console.warn("Failed to load nudge data, falling back to defaults", error);
        nudgeData = NudgeData.createEmpty(nudgeType, saveFn);
    }

    return nudgeData;
}

export function saveNudge(nudgeType: NudgeType, nudgeData: NudgeData): void {
    const key = getNudgeStorageKey(nudgeType);
    const serialized = nudgeData.serialize();
    writeBrowserStorageJSON(key, serialized);
}
